import { ROLES_LABELS } from 'constants/userRoles';

export const getUserRoleLabel = (role) => {
  return ROLES_LABELS[role] || 'n/a';
};
